var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g, _ellipse, _g2, _g3, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _circle, _circle2, _circle3, _circle4, _path34, _path35, _path36, _circle5, _circle6, _circle7, _path37, _path38, _path39, _path40, _circle8, _path41, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoyaltyOffers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 377,
    height: 287,
    viewBox: "0 0 377 287",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M219.012 34.6213C219.012 34.6213 217.308 21.3674 216.583 18.1285C215.475 13.0997 209.935 13.6537 209.935 13.6537C209.935 13.6537 179.464 12.8866 175.522 13.5259C171.58 14.1651 171.708 17.9154 171.708 17.9154L180.423 91.0248C180.423 91.0248 180.359 98.1206 187.966 98.2271C195.573 98.3337 220.589 98.7811 220.589 98.7811C220.589 98.7811 226.854 98.1845 225.959 92.005C225.021 85.4207 223.615 76.0876 223.615 76.0876",
    stroke: "#195096",
    strokeWidth: 2.85935,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M198.641 92.2148L210.68 92.4066",
    stroke: "#195096",
    strokeWidth: 2.85935,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M172.859 14.7598L168.853 18.297C168.853 18.297 165.87 20.5983 166.381 24.0077C166.893 27.417 174.99 96.8827 174.99 96.8827C174.99 96.8827 176.034 103.147 181.681 103.68C187.327 104.213 215.838 104.149 215.838 104.149C215.838 104.149 218.523 103.787 219.844 102.444C221.165 101.102 225.193 96.2008 225.193 96.2008",
    stroke: "#195096",
    strokeWidth: 2.85935,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M184.238 40.4805H190.29",
    stroke: "#195096",
    strokeWidth: 2.78787,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M184.238 40.4805L184.941 46.2764",
    stroke: "#195096",
    strokeWidth: 2.78787,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M222.336 40.4805L223.082 46.5321",
    stroke: "#195096",
    strokeWidth: 2.78787,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M222.337 40.4805H216.541",
    stroke: "#195096",
    strokeWidth: 2.78787,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M225.938 69.9258H219.887",
    stroke: "#195096",
    strokeWidth: 2.78787,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M225.937 69.9268L225.213 64.1309",
    stroke: "#195096",
    strokeWidth: 2.78787,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M187.838 69.9266L187.092 63.875",
    stroke: "#195096",
    strokeWidth: 2.78787,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M187.84 69.9258H193.636",
    stroke: "#195096",
    strokeWidth: 2.78787,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M193.611 47.9785L195.359 62.2978",
    stroke: "#195096",
    strokeWidth: 2.85935,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M197.787 47L199.79 63.4502",
    stroke: "#195096",
    strokeWidth: 1.42968,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M212.406 47.1035L214.409 63.4897",
    stroke: "#195096",
    strokeWidth: 1.42968,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M215.496 47.1035L217.499 63.4897",
    stroke: "#195096",
    strokeWidth: 1.42968,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M202.477 47.9785L204.245 62.2978",
    stroke: "#195096",
    strokeWidth: 2.85935,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M208.209 47.9785L209.956 62.2978",
    stroke: "#195096",
    strokeWidth: 2.85935,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M199.751 21.3443C200.092 23.0064 198.983 24.3488 197.257 24.3488C195.531 24.3488 193.869 23.0064 193.55 21.3443C193.23 19.6823 194.317 18.3398 196.043 18.3398C197.769 18.3398 199.431 19.6823 199.751 21.3443Z",
    fill: "#195096"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25063_216023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.963 87.9003C139.963 87.9003 138.058 83.1892 136.922 81.0689C135.171 77.7737 131.411 79.2377 131.411 79.2377C131.411 79.2377 109.989 84.6273 107.361 85.8401C104.733 87.0529 105.552 89.6462 105.552 89.6462L125.852 138.991C125.852 138.991 127.187 143.957 132.519 142.552C137.85 141.147 155.402 136.595 155.402 136.595C155.402 136.595 159.5 135.021 157.833 130.821C156.105 126.461 154.455 123.009 154.455 123.009",
    stroke: "#195096",
    strokeWidth: 2.47075,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.967 99.2448L120.445 100.354L119.035 97.0759C119.035 97.0759 118.04 94.4836 121.467 93.3206C124.875 92.1469 125.66 95.3106 125.66 95.3106C125.66 95.3106 134.492 116.255 137.718 123.98C138.789 126.503 141.951 126.344 142.966 125.212C144.451 123.58 143.501 121.552 143.501 121.552L141.992 118.205L163.431 112.474L164.809 115.809C164.809 115.809 166.097 119.169 162.276 120.298C158.941 121.275 142.06 125.816 142.06 125.816",
    stroke: "#195096",
    strokeWidth: 2.47075,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.896 93.5117L142.067 87.9677C142.067 87.9677 146.33 87.101 148.072 90.8798C149.793 94.5842 156.325 110.382 156.325 110.382",
    stroke: "#195096",
    strokeWidth: 2.47075,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.891 102.003C150.513 105.639 148.535 109.3 144.482 110.172C140.429 111.045 135.828 108.8 134.217 105.145C132.606 101.49 134.573 97.848 138.626 96.9755C142.68 96.1031 147.28 98.3482 148.891 102.003Z",
    stroke: "#195096",
    strokeWidth: 2.47075,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.239 107.084L124.895 104.872",
    stroke: "#195096",
    strokeWidth: 2.47075,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.789 136.283L147.231 134.076",
    stroke: "#195096",
    strokeWidth: 2.47075,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.046 110.746L126.697 108.518",
    stroke: "#195096",
    strokeWidth: 2.47075,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.847 114.401L128.502 112.188",
    stroke: "#195096",
    strokeWidth: 2.47075,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.728 87.225L103.619 90.4734C103.619 90.4734 101.984 92.6601 103.003 94.9408C104.023 97.2215 123.184 144.143 123.184 144.143C123.184 144.143 125.131 148.313 129.177 147.587C133.222 146.861 153.114 141.272 153.114 141.272C153.114 141.272 154.918 140.497 155.579 139.303C156.24 138.109 158.099 133.905 158.099 133.905",
    stroke: "#195096",
    strokeWidth: 2.47075,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.611 104.462L145.435 104.714C145.435 104.714 145.572 104.804 145.559 104.871C145.333 106.073 144.724 106.707 143.625 106.965C142.087 107.313 140.418 106.672 139.242 105.269L138.362 105.449C138.362 105.449 138.197 105.431 138.176 105.357L137.86 104.74C137.86 104.74 137.867 104.593 137.942 104.573L138.668 104.418C138.605 104.308 138.538 104.182 138.475 104.071C138.404 103.931 138.352 103.801 138.289 103.69L138.272 103.631L137.516 103.793C137.442 103.814 137.351 103.775 137.33 103.701L137.018 103.099C137.018 103.099 137.026 102.952 137.1 102.932L138.009 102.742C137.739 101.199 138.479 99.9987 139.879 99.6728C141.383 99.318 142.55 99.9388 143.298 100.436C143.359 100.483 143.394 100.553 143.347 100.614L142.913 101.184C142.913 101.184 142.872 101.212 142.828 101.224C142.798 101.232 142.76 101.211 142.722 101.189C141.907 100.679 141.236 100.401 140.331 100.605C139.5 100.788 139.084 101.481 139.182 102.464L141.759 101.874C141.759 101.874 141.924 101.892 141.945 101.967L142.257 102.569C142.257 102.569 142.249 102.716 142.175 102.736L139.375 103.388C139.416 103.537 139.488 103.677 139.563 103.833C139.615 103.962 139.697 104.084 139.764 104.209L142.579 103.553C142.579 103.553 142.744 103.572 142.765 103.646L143.081 104.263C143.081 104.263 143.074 104.409 143 104.43L140.378 105.032C141.206 105.876 142.228 106.264 143.163 106.052C143.87 105.887 144.234 105.465 144.431 104.561C144.426 104.546 144.463 104.504 144.492 104.495C144.522 104.487 144.605 104.496 144.605 104.496L144.611 104.462Z",
    fill: "#195096"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 192.896,
    cy: 249.344,
    rx: 93.5033,
    ry: 36.9396,
    fill: "#E6ECF3"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_25063_216023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.497 221.774L266.456 239.01L223.568 228.954L227.609 211.719",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.497 221.774L266.456 239.01L223.568 228.954L227.609 211.719",
    stroke: "#195096",
    strokeWidth: 2.27873,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.192 203.362L232.897 193.914C229.361 193.085 225.818 195.283 224.989 198.818L224.823 199.526C223.958 203.214 225.892 207.134 229.471 208.339C232.564 209.372 235.757 208.233 237.56 205.847C238.001 208.145 239.54 210.129 241.741 211.099L241.768 211.105C241.914 211.169 242.074 211.236 242.224 211.285C242.293 211.302 242.342 211.342 242.411 211.359C242.481 211.375 242.564 211.394 242.633 211.411C242.758 211.44 242.876 211.497 243.015 211.529C243.098 211.549 243.184 211.554 243.282 211.577C243.517 211.632 243.746 211.657 243.974 211.681C244.074 211.69 244.188 211.702 244.289 211.711C244.621 211.73 244.928 211.729 245.256 211.704C247.34 211.549 249.249 210.519 250.497 208.88C251.013 211.605 253.078 213.903 255.949 214.576C256.046 214.599 256.146 214.608 256.246 214.617C256.385 214.65 256.534 214.699 256.676 214.718C259.436 215.175 262.063 213.889 263.652 211.731C264.124 214.709 266.4 217.232 269.613 217.751C273.429 218.383 277.017 215.684 277.898 211.926L278.057 211.247C278.886 207.711 276.689 204.167 273.153 203.338L273.192 203.362Z",
    stroke: "#195096",
    strokeWidth: 2.27873,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.718 197.945L252.779 189.154L257.459 193.279L256.07 199.2",
    stroke: "#195096",
    strokeWidth: 2.27873,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.238 187.931C251.92 183.452 255.231 176.753 259.19 175.341C262.443 180.185 260.641 185.935 256.238 187.931Z",
    stroke: "#195096",
    strokeWidth: 2.27873,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.119 184L255.377 191.432",
    stroke: "#195096",
    strokeWidth: 2.27873,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.06 216.024C236.241 215.892 237.418 214.866 237.418 214.866L235.071 224.877",
    stroke: "#195096",
    strokeWidth: 2.27873,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.564 223.584C255.843 223.884 257.122 223.091 257.422 221.812C257.722 220.533 256.928 219.253 255.65 218.953C254.371 218.653 253.091 219.447 252.791 220.726C252.491 222.005 253.285 223.284 254.564 223.584Z",
    stroke: "#195096",
    strokeWidth: 2.27873,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.252 227.046C246.192 227.735 249.135 225.911 249.824 222.97C250.514 220.029 248.689 217.086 245.748 216.397C242.808 215.707 239.865 217.532 239.175 220.473C238.486 223.414 240.311 226.356 243.252 227.046Z",
    stroke: "#195096",
    strokeWidth: 2.27873,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.929 231.057C260.208 231.357 261.488 230.563 261.788 229.284C262.087 228.005 261.294 226.726 260.015 226.426C258.736 226.126 257.456 226.92 257.156 228.198C256.856 229.477 257.65 230.757 258.929 231.057Z",
    stroke: "#195096",
    strokeWidth: 2.27873,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.338 229.35L262.039 220.668",
    stroke: "#195096",
    strokeWidth: 2.27873,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.902 219.031L232.537 219.649",
    stroke: "#195096",
    strokeWidth: 2.27873,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_25063_216023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.769 151.76C288.425 153.474 286.772 154.582 285.073 154.246L225.503 142.447C223.803 142.11 222.695 140.458 223.039 138.743L229.992 103.678C230.337 101.964 231.989 100.856 233.689 101.192L293.252 112.969C294.951 113.305 296.059 114.958 295.715 116.672L288.769 151.76Z",
    stroke: "#195096",
    strokeWidth: 2.65151,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.617 127.58L275.522 133.375C275.662 133.241 275.861 133.099 276.105 132.979C276.363 132.866 276.637 132.76 276.948 132.691C277.259 132.623 277.577 132.576 277.918 132.559C278.258 132.542 278.592 132.576 278.911 132.641C279.52 132.756 280.04 132.974 280.479 133.283C280.919 133.591 281.27 133.967 281.532 134.41C281.794 134.852 281.968 135.363 282.046 135.918C282.124 136.473 282.12 137.044 282.028 137.645C282.014 137.749 282 137.816 282.007 137.875L281.041 142.995C281.013 143.166 280.94 143.278 280.829 143.352C280.718 143.427 280.585 143.436 280.444 143.422L278.752 143.107C278.567 143.071 278.448 143.013 278.38 142.924C278.335 142.828 278.32 142.71 278.348 142.539L279.321 137.404C279.422 136.862 279.329 136.374 279.022 135.909C278.73 135.451 278.313 135.172 277.772 135.072C277.519 135.022 277.223 135.024 276.927 135.063C276.608 135.11 276.32 135.208 276.039 135.328C275.751 135.464 275.5 135.636 275.301 135.852C275.088 136.061 274.964 136.314 274.906 136.581L273.925 141.731C273.89 141.917 273.794 142.036 273.653 142.059C273.513 142.082 273.365 142.083 273.209 142.062L271.702 141.783C271.346 141.719 271.197 141.535 271.261 141.216L273.938 127.131C273.974 126.982 274.026 126.878 274.121 126.796C274.217 126.714 274.35 126.706 274.506 126.727L276.161 127.042C276.31 127.078 276.429 127.136 276.503 127.21C276.593 127.291 276.616 127.431 276.58 127.617",
    fill: "#195096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.365 135.399C241.364 135.25 241.363 135.139 241.37 135.05C241.376 134.961 241.376 134.85 241.375 134.702C241.228 134.851 241.058 135.008 240.874 135.157C240.69 135.307 240.483 135.427 240.254 135.517C240.025 135.608 239.773 135.669 239.484 135.693C239.195 135.717 238.869 135.704 238.483 135.626L238.453 135.611C237.741 135.482 237.094 135.22 236.536 134.853C235.985 134.471 235.53 134.008 235.185 133.469C234.841 132.93 234.607 132.317 234.476 131.643C234.346 130.969 234.356 130.273 234.492 129.545C234.628 128.818 234.875 128.164 235.235 127.584C235.594 127.003 236.035 126.519 236.552 126.145C237.068 125.771 237.659 125.507 238.31 125.347C238.954 125.202 239.658 125.197 240.385 125.333C241.098 125.462 241.633 125.725 241.976 126.078C242.32 126.432 242.611 126.852 242.852 127.303L243.21 126.574C243.305 126.344 243.385 126.217 243.474 126.15C243.562 126.083 243.696 126.074 243.881 126.11L245.01 126.369C245.158 126.405 245.292 126.471 245.382 126.589C245.486 126.714 245.524 126.862 245.488 127.011L243.792 135.909C243.763 136.079 243.675 136.184 243.534 136.244C243.394 136.304 243.253 136.327 243.105 136.291L241.806 136.04C241.606 135.997 241.472 135.932 241.419 135.813C241.367 135.695 241.343 135.554 241.35 135.391M237.156 130.061C237.084 130.432 237.072 130.795 237.119 131.151C237.173 131.491 237.294 131.809 237.451 132.09C237.624 132.378 237.84 132.613 238.116 132.804C238.391 132.995 238.711 133.134 239.067 133.198C239.824 133.349 240.468 133.203 241.006 132.785C241.544 132.366 241.874 131.771 242.024 131.014C242.096 130.643 242.101 130.295 242.054 129.939C242.007 129.584 241.901 129.273 241.736 128.97C241.564 128.683 241.355 128.432 241.079 128.241C240.811 128.035 240.469 127.904 240.083 127.825C239.712 127.754 239.371 127.771 239.038 127.847C238.705 127.924 238.41 128.074 238.159 128.283C237.909 128.492 237.688 128.753 237.505 129.051C237.322 129.349 237.198 129.675 237.141 130.054",
    fill: "#195096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.725 125.346C254.789 124.99 255.033 124.832 255.47 124.881L257.012 124.938C257.012 124.938 257.086 124.937 257.161 124.937C257.346 124.972 257.473 125.053 257.518 125.186C257.563 125.319 257.564 125.467 257.536 125.638L256.97 128.592L258.187 128.821C258.358 128.849 258.47 128.922 258.552 129.055C258.642 129.173 258.658 129.329 258.622 129.514L258.407 130.628C258.371 130.85 258.283 130.992 258.165 131.081C258.047 131.171 257.907 131.194 257.743 131.151L256.526 130.922L255.188 137.964C255.152 138.15 255.086 138.284 254.983 138.381C254.887 138.463 254.724 138.494 254.524 138.45L252.817 138.128C252.617 138.085 252.483 138.019 252.445 137.909C252.393 137.79 252.392 137.642 252.427 137.457L253.766 130.414L253.224 130.314C252.838 130.235 252.681 129.992 252.76 129.569L252.975 128.455C253.053 128.07 253.282 127.905 253.668 127.984L254.21 128.084L254.725 125.346Z",
    fill: "#195096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.103 140.101C266.102 139.952 266.101 139.841 266.108 139.752C266.115 139.663 266.114 139.552 266.113 139.404C265.966 139.553 265.796 139.71 265.612 139.859C265.428 140.009 265.221 140.129 264.992 140.219C264.763 140.31 264.511 140.371 264.222 140.395C263.933 140.419 263.607 140.406 263.221 140.328L263.191 140.313C262.479 140.184 261.833 139.922 261.274 139.555C260.723 139.173 260.268 138.709 259.923 138.171C259.586 137.617 259.345 137.018 259.215 136.345C259.084 135.671 259.094 134.975 259.23 134.247C259.366 133.52 259.614 132.866 259.973 132.286C260.332 131.705 260.773 131.221 261.29 130.847C261.806 130.472 262.397 130.209 263.048 130.049C263.692 129.904 264.396 129.899 265.123 130.035C265.836 130.164 266.371 130.427 266.714 130.78C267.058 131.134 267.35 131.554 267.59 132.005L267.948 131.276C268.043 131.046 268.124 130.919 268.212 130.852C268.3 130.785 268.434 130.776 268.619 130.812L269.748 131.071C269.896 131.107 270.03 131.173 270.12 131.291C270.224 131.416 270.262 131.564 270.226 131.713L268.53 140.61C268.501 140.781 268.413 140.885 268.273 140.946C268.132 141.006 267.991 141.029 267.843 140.993L266.544 140.742C266.344 140.699 266.21 140.633 266.157 140.515C266.105 140.397 266.082 140.256 266.088 140.093M262.403 126.666C262.474 126.258 262.68 125.953 263.012 125.729C263.344 125.504 263.699 125.42 264.1 125.506C264.523 125.585 264.828 125.79 265.053 126.122C265.277 126.454 265.339 126.817 265.268 127.225C265.189 127.611 264.998 127.924 264.666 128.148C264.349 128.38 263.964 128.449 263.556 128.378C263.17 128.299 262.857 128.109 262.633 127.777C262.408 127.445 262.324 127.089 262.411 126.689M261.879 134.756C261.808 135.127 261.795 135.49 261.842 135.845C261.896 136.186 262.017 136.504 262.175 136.785C262.347 137.072 262.564 137.308 262.839 137.499C263.115 137.69 263.434 137.828 263.79 137.893C264.547 138.043 265.191 137.898 265.729 137.479C266.268 137.061 266.597 136.466 266.748 135.709C266.819 135.338 266.824 134.989 266.777 134.634C266.731 134.278 266.625 133.968 266.46 133.665C266.287 133.377 266.078 133.127 265.803 132.936C265.534 132.73 265.193 132.599 264.807 132.52C264.436 132.448 264.095 132.466 263.762 132.542C263.429 132.618 263.133 132.769 262.883 132.978C262.632 133.187 262.412 133.448 262.228 133.745C262.045 134.043 261.921 134.37 261.864 134.748M266.536 127.424C266.608 127.016 266.82 126.696 267.152 126.471C267.484 126.247 267.84 126.163 268.233 126.227C268.656 126.306 268.976 126.518 269.186 126.843C269.41 127.175 269.465 127.553 269.393 127.961C269.314 128.347 269.124 128.659 268.792 128.884C268.475 129.116 268.09 129.185 267.682 129.114C267.296 129.035 266.983 128.844 266.758 128.512C266.534 128.18 266.45 127.825 266.536 127.424Z",
    fill: "#195096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.871 127.514L249.074 136.954C249.017 137.258 248.825 137.385 248.484 137.328L246.725 136.999C246.421 136.942 246.293 136.75 246.351 136.446L248.054 127.496C248.09 127.348 248.134 127.259 248.23 127.176C248.319 127.109 248.452 127.101 248.607 127.085L250.452 126.939C250.585 126.931 250.697 127.004 250.779 127.1C250.876 127.203 250.892 127.359 250.856 127.507",
    fill: "#195096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.065 105.643L251.258 123.678C251.179 124.064 250.957 124.103 250.646 124.172L248.825 124.384C248.551 124.415 248.408 124.105 248.502 123.726L252.423 105.194L255.08 105.65L255.065 105.643Z",
    fill: "#195096"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M176.207 151.957C179.206 148.495 183.25 145.85 188.011 144.566C200.716 141.139 213.781 148.653 217.207 161.359C220.634 174.064 213.12 187.129 200.414 190.556C187.709 193.982 174.644 186.468 171.217 173.763",
    stroke: "#195096",
    strokeWidth: 2.35517,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M166.271 175.084L170.038 169.494",
    stroke: "#195096",
    strokeWidth: 2.35517,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M176.161 172.418L170.094 169.48",
    stroke: "#195096",
    strokeWidth: 2.35517,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M178.701 165.723C181.85 163.776 182.786 161.312 182.786 161.312L187.317 178.111",
    stroke: "#195096",
    strokeWidth: 2.35517,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M192.937 165.817C195.025 165.253 196.261 163.104 195.698 161.017C195.134 158.929 192.985 157.693 190.898 158.256C188.81 158.819 187.574 160.968 188.137 163.056C188.7 165.144 190.849 166.38 192.937 165.817Z",
    stroke: "#195096",
    strokeWidth: 2.35517,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M205.113 173.268C207.2 172.705 208.436 170.556 207.873 168.468C207.31 166.38 205.161 165.144 203.073 165.707C200.986 166.27 199.749 168.419 200.313 170.507C200.876 172.595 203.025 173.831 205.113 173.268Z",
    stroke: "#195096",
    strokeWidth: 2.35517,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M194.206 175.952L201.524 155.774",
    stroke: "#195096",
    strokeWidth: 2.35517,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M211.015 235.296C211.118 232.282 208.826 228.921 205.98 227.763C205.671 227.634 205.272 227.466 205.143 227.196C204.242 225.367 203.675 223.462 204.087 221.401C204.126 221.182 204.68 220.745 204.86 220.629C207.281 219.083 207.667 216.83 207.86 214.177C208.015 211.937 206.792 210.623 204.551 210.288C201.435 209.825 198.357 210.211 195.318 210.906C193.399 211.344 191.893 212.49 191.687 214.576C191.506 216.456 191.648 218.362 191.648 220.281C192.202 220.165 193.026 220.126 193.554 220.126C193.876 222.805 193.129 225.522 192.305 228.033C192.266 228.162 188.004 230.454 186.394 231.87C186.304 231.149 186.175 229.862 186.059 228.857C184.991 229.05 184.025 229.218 183.123 229.372C183.342 233.493 183.561 237.511 183.78 241.696C186.059 239.61 188.287 237.614 191.571 237.446V234.253C190.27 234.523 188.995 234.781 187.63 235.064C189.472 232.772 195.254 230.299 195.305 230.003C195.717 227.325 196.142 224.646 196.387 221.955C196.516 220.487 196.387 218.942 195.202 217.809C194.288 216.946 194.584 215.864 194.79 214.924C194.893 214.473 195.666 213.945 196.194 213.868C198.138 213.572 200.095 213.34 202.066 213.289C204.834 213.224 205.697 213.327 204.306 216.688C204.087 217.216 203.469 217.899 202.993 218.053C201.769 218.44 201.357 219.186 201.139 220.294C200.508 223.397 200.971 226.398 202.079 229.321C202.207 229.655 202.671 229.926 203.031 230.119C203.984 230.634 205.066 230.956 205.916 231.6C207.152 232.54 207.77 233.956 208.028 235.566C209.032 235.476 209.985 235.373 211.015 235.283V235.296ZM209.522 260.767C209.612 261.578 209.728 262.544 209.843 263.6C210.886 263.406 211.814 263.226 212.638 263.072C212.406 259.093 212.174 255.075 211.942 251.122C211.762 251.444 208.955 254.096 205.272 255.204C205.221 256.105 205.169 257.058 205.118 258.165C206.302 257.895 207.616 257.586 208.414 257.393C207.513 258.204 206.148 259.208 205.053 259.814C200.752 262.183 196.155 263.007 191.3 262.106C188.983 261.668 186.845 260.87 186.253 258.114C185.184 258.23 184.166 258.346 183.098 258.462C183.162 258.887 183.188 259.196 183.252 259.505C183.935 262.402 185.995 263.973 188.648 264.797C193.786 266.407 198.872 265.905 203.791 263.909C205.787 263.097 207.603 261.835 209.522 260.767Z",
    fill: "#195096"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M201.821 251.856L201.113 249.795H195.486L194.778 251.856H190.605L195.975 237.588H200.624L205.994 251.856H201.821ZM198.306 241.232L196.49 246.602H200.109L198.306 241.232Z",
    fill: "#195096"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M167.32 223.885L128.375 233.645C127.92 231.833 126.09 230.741 124.277 231.185L118.798 209.311C120.611 208.856 121.703 207.026 121.259 205.213L160.193 195.453C160.648 197.266 162.478 198.358 164.291 197.914L169.782 219.797C167.969 220.252 166.877 222.082 167.321 223.896L167.32 223.885Z",
    fill: "white",
    stroke: "#195096",
    strokeWidth: 1.77911,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M148.026 212.521C149.847 212.422 151.243 210.865 151.144 209.044C151.045 207.223 149.488 205.827 147.667 205.926C145.846 206.025 144.45 207.582 144.549 209.403C144.648 211.224 146.205 212.62 148.026 212.521Z",
    stroke: "#195096",
    strokeWidth: 1.77911,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M158.188 218.98C160.009 218.881 161.405 217.324 161.306 215.503C161.207 213.682 159.65 212.286 157.829 212.385C156.008 212.484 154.612 214.041 154.711 215.862C154.81 217.683 156.367 219.079 158.188 218.98Z",
    stroke: "#195096",
    strokeWidth: 1.77911,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M149.579 220.987L156.041 204.076",
    stroke: "#195096",
    strokeWidth: 1.77911,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M125.932 219.425L129.997 218.413",
    stroke: "#195096",
    strokeWidth: 1.77911,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M134.902 223.035C136.167 223.969 137.914 224.352 139.672 223.911C142.605 223.172 144.449 220.433 143.792 217.785C143.125 215.137 140.212 213.592 137.279 214.331L133.851 215.186L132.5 209.803L140.223 207.868",
    stroke: "#195096",
    strokeWidth: 1.77911,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.96807,
    cy: 5.96807,
    r: 5.96807,
    transform: "matrix(-0.975917 -0.218143 -0.218143 0.975917 345.75 118.545)",
    stroke: "#E6ECF3",
    strokeWidth: 2.65248
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.96807,
    cy: 5.96807,
    r: 5.96807,
    transform: "matrix(-0.975917 -0.218143 -0.218143 0.975917 359.678 68.6367)",
    stroke: "#E6ECF3",
    strokeWidth: 2.65248
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.96807,
    cy: 5.96807,
    r: 5.96807,
    transform: "matrix(-0.975917 -0.218143 -0.218143 0.975917 319.055 44.2637)",
    stroke: "#E6ECF3",
    strokeWidth: 2.65248
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.97871,
    cy: 3.97871,
    r: 3.97871,
    transform: "matrix(-0.975917 -0.218143 -0.218143 0.975917 328.23 107.229)",
    stroke: "#E6ECF3",
    strokeWidth: 2.32124
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M274.047 86.3435C311.186 45.1416 355.702 87.0781 366.053 23.0898M291.456 95.1584C305.964 80.6507 324.533 92.2568 333.238 86.3435",
    stroke: "#E6ECF3",
    strokeWidth: 2.32124,
    strokeDasharray: "6.96 3.48"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.039 62.0418C289.719 60.5332 291.848 58.1142 292.902 54.3372L285.842 52.3236C285.318 54.1994 284.45 55.0561 283.422 55.6346C282.158 56.3464 280.544 56.7071 278.212 57.1816C278.141 57.1961 278.069 57.2107 277.996 57.2254C275.936 57.6433 273.24 58.1904 270.88 59.5189C268.2 61.0275 266.072 63.4464 265.017 67.2235L272.078 69.2371C272.601 67.3613 273.47 66.5046 274.498 65.926C275.762 65.2143 277.375 64.8535 279.708 64.3791C279.779 64.3646 279.851 64.35 279.923 64.3353C281.983 63.9174 284.68 63.3703 287.039 62.0418Z",
    fill: "white",
    stroke: "#E6ECF3",
    strokeWidth: 2.32124
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2906 208.747C63.7536 182.785 56.0464 218.684 25.0282 211.373M113.677 194.957C80.1874 152.931 21.7152 197.612 27.9883 129.291",
    stroke: "#E6ECF3",
    strokeWidth: 2.62663,
    strokeDasharray: "7.88 3.94"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.75326,
    cy: 6.75326,
    r: 6.75326,
    transform: "matrix(-0.975917 -0.218143 -0.218143 0.975917 62.168 146.684)",
    stroke: "#E6ECF3",
    strokeWidth: 3.00145
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.50217,
    cy: 4.50217,
    r: 4.50217,
    transform: "matrix(-0.975917 -0.218143 -0.218143 0.975917 69.9258 132.568)",
    stroke: "#E6ECF3",
    strokeWidth: 2.62663
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.50217,
    cy: 4.50217,
    r: 4.50217,
    transform: "matrix(-0.975917 -0.218143 -0.218143 0.975917 75.1797 219.248)",
    stroke: "#E6ECF3",
    strokeWidth: 2.62663
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.962 164.377C94.9246 162.68 92.5075 159.95 91.3017 155.679L99.2839 153.377C99.8828 155.497 100.869 156.464 102.033 157.115C103.467 157.916 105.294 158.319 107.935 158.848C108.015 158.864 108.096 158.88 108.179 158.896C110.511 159.362 113.564 159.972 116.239 161.467C119.276 163.165 121.693 165.895 122.899 170.165L114.917 172.468C114.318 170.347 113.332 169.381 112.167 168.73C110.734 167.929 108.907 167.526 106.266 166.997C106.186 166.981 106.104 166.965 106.022 166.948C103.69 166.482 100.637 165.873 97.962 164.377Z",
    fill: "white",
    stroke: "#E6ECF3",
    strokeWidth: 2.62663
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.0407 60.2452C89.0167 59.0957 86.4231 56.9129 84.7346 53.1488L91.7638 49.9479C92.6023 51.8171 93.6402 52.5723 94.8 53.0131C96.2267 53.5554 97.9618 53.6778 100.463 53.8059C100.539 53.8098 100.616 53.8137 100.694 53.8177C102.902 53.9297 105.793 54.0763 108.456 55.0886C111.48 56.238 114.073 58.4209 115.762 62.1849L108.733 65.3859C107.894 63.5166 106.856 62.7615 105.696 62.3207C104.27 61.7784 102.535 61.6559 100.034 61.5278C99.9576 61.5239 99.8806 61.52 99.8026 61.516C97.5943 61.404 94.7038 61.2574 92.0407 60.2452Z",
    fill: "white",
    stroke: "#E6ECF3",
    strokeWidth: 2.44199
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.287 22.7499C135.201 19.7024 133.073 17.0636 129.345 15.2966L125.998 22.2571C127.849 23.1347 128.582 24.1882 128.999 25.3569C129.511 26.7947 129.597 28.532 129.673 31.0349C129.675 31.1111 129.677 31.1882 129.679 31.2662C129.745 33.4764 129.831 36.3694 130.787 39.0531C131.873 42.1005 134.001 44.7393 137.729 46.5064L141.077 39.5458C139.225 38.6683 138.492 37.6147 138.076 36.446C137.563 35.0082 137.477 33.271 137.402 30.7681C137.399 30.6918 137.397 30.6147 137.395 30.5367C137.329 28.3266 137.243 25.4336 136.287 22.7499Z",
    fill: "white",
    stroke: "#E6ECF3",
    strokeWidth: 2.44199
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.017 13.0417C102.855 10.6351 99.884 9.00248 95.7644 8.78394L95.3118 16.4944C97.3576 16.6029 98.4361 17.299 99.2652 18.2219C100.285 19.3573 101.025 20.9317 102.046 23.2182C102.077 23.2878 102.108 23.3583 102.14 23.4296C103.04 25.4491 104.219 28.0926 106.123 30.2119C108.285 32.6184 111.256 34.2511 115.375 34.4696L115.828 26.7592C113.782 26.6506 112.703 25.9546 111.874 25.0317C110.854 23.8963 110.115 22.3219 109.094 20.0354C109.063 19.9657 109.032 19.8952 109 19.824C108.099 17.8044 106.921 15.161 105.017 13.0417Z",
    fill: "white",
    stroke: "#E6ECF3",
    strokeWidth: 2.44199
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.89054,
    cy: 3.89054,
    r: 3.89054,
    transform: "matrix(-0.496318 -0.868141 -0.868141 0.496318 306.99 194.141)",
    stroke: "#E6ECF3",
    strokeWidth: 2.26979
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.606 174.011C295.807 171.962 298.693 170.697 302.525 170.836L302.304 178.012C300.401 177.943 299.345 178.498 298.501 179.283C297.463 180.25 296.647 181.646 295.513 183.678C295.478 183.74 295.443 183.803 295.408 183.866C294.407 185.661 293.097 188.011 291.158 189.815C288.957 191.863 286.071 193.128 282.239 192.989L282.46 185.813C284.363 185.883 285.419 185.328 286.263 184.542C287.302 183.575 288.117 182.179 289.251 180.147C289.286 180.085 289.321 180.022 289.356 179.959C290.357 178.164 291.668 175.815 293.606 174.011Z",
    fill: "white",
    stroke: "#E6ECF3",
    strokeWidth: 2.26979
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25063_216023"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.6624,
    height: 83.6624,
    fill: "white",
    transform: "translate(83 82.4492) rotate(-15.5643)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_25063_216023"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72.3592,
    height: 72.3592,
    fill: "white",
    transform: "translate(224.42 161.613) rotate(13.1956)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_25063_216023"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95.3771,
    height: 95.3771,
    fill: "white",
    transform: "translate(238.438 64.6465) rotate(26.1795)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoyaltyOffers);
export default __webpack_public_path__ + "static/media/loyalty_offers.66ffee1c32086afb51599b2c3ba798c5.svg";
export { ForwardRef as ReactComponent };